export const getPortal = store => store.portal;
export const getRoutes = store => store.categories.routes;
export const getCategories = store => store.categories;
export const getLoading = store => store.loading.isLoading;
export const getPathParams = store => store.pathParams;
export const getMenuCategories = store => store.menuCategories;
export const getProducts = store => store.products.products;
export const getCurrProduct = store => store.currProduct.currProduct;
